import {
  addSlug,
  geolocationSchema,
  slimUserSchema,
  thumbnailRequiredSchema,
} from 'shared';
import {z} from 'zod';

const baseSchema = z.object({
  id: z.string(),
  thumbnail: z.string(),
  location: geolocationSchema.nullable(),
  name: z.string(),
  modified: z.coerce.date(),
  created: z.coerce.date(),
  assetCount: z.number().nonnegative(),
});

export const siteSchema = baseSchema
  .extend({
    createdBy: slimUserSchema.nullable().default(null),
  })
  .transform(addSlug);

export const siteListSchema = baseSchema.transform(addSlug).array();

export const sitePayloadSchema = z.object({
  name: z.string().trim().min(2).max(30),
  thumbnail: thumbnailRequiredSchema,
});
